const capitalizeFirstLetter = (string) => {
  let finalString = "";
  if (string) {
    finalString = string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
  }
  return finalString;
};

export const mobileInsuranceNormalizer = (mobileInsuranceInfo) => {
  const { type, payload } = mobileInsuranceInfo;
  let response;
  if (payload && type === "TS") {
    const legalConditions = payload.legalConditions.html;
    let insurances = [];
    if (Array.isArray(payload.entity)) {
      const filteredEntities = payload.entity.filter(
        (entity) => entity.typeCode !== "NS"
      );
      insurances = filteredEntities.map(entity => ({
        tsType: entity.typeCode,
        texts: {
          name: entity.nombre,
          description: entity.descripcion,
          characteristics: entity.displays.find(({ display }) => display?.textFlyout)?.display?.textFlyout?.texto,
          promotionText: capitalizeFirstLetter(entity.promo)
        },
        prices: {
          recurringPrice: entity.tarifa,
          recurringPromotedPrice: entity.tarifaPromocionada
        }
      }))
    }
    response = {
      legalConditions,
      insurances
    }
  } else {
    response = payload;
  }

  return response;
};
